import React from 'react'
import banner from "../../../images/padu/shake.webp";

export default function Shake() {
  return (
    <div className='mb-[20px] sm:mb-[50px] xl:mb-[70px] p-[20px] relative z-0 w-full overflow-hidden text-center bg-[#F2F2F7] border-y border-[#F3F4F6]'>
        <img src={banner} alt='banner' className='mx-auto' loading='lazy' />
        <p className='mt-[10px] md:mt-[20px] text-[#6A7282] text-[16px] md:text-[22px] font-medium'>Colleges, faculty and industry professionals across India trust Surge to uplift student clarity, confidence and readiness.</p>
        <div className='mt-[10px] md:mt-[20px] flex gap-[20px] md:gap-[40px] lg:gap-[60px] flex-wrap justify-center items-center text-[#8A8A8A] text-[18px] md:text-[24px] font-bold'>
            <p>IIT Kharagpur </p>
            <p>IIT Bombay</p>
            <p>VIT</p>
            <p>IIMA ahmedabad</p>
            <p>Loyola</p>
        </div>
    </div>
  )
}
